import { urlSearchTerm, urlSegmentId } from 'pages/contacts/constants/constants'

export type ContactsQueryState = {
  segmentId: number | null
  filterEntries: Array<[string, string]>
  search: string
}

const isFilterGroupKey = (key: string) => /^\d+$/.test(key)

// Read by name, never by position: the query carries the segment id, the ad-hoc
// filter groups under numeric keys, and the search term, in whatever order the
// last write left them.
export const parseContactsQuery = (queryString: string): ContactsQueryState => {
  const params = new URLSearchParams(queryString)
  const rawSegmentId = params.get(urlSegmentId)?.trim()
  const segmentId = rawSegmentId ? Number(rawSegmentId) : null

  return {
    segmentId: segmentId === null || Number.isNaN(segmentId) ? null : segmentId,
    filterEntries: [...params.entries()].filter(([key]) => isFilterGroupKey(key)),
    search: params.get(urlSearchTerm) ?? '',
  }
}

export const withSearchTerm = (queryString: string, term: string): string => {
  const params = new URLSearchParams(queryString)

  if (term.trim()) {
    params.set(urlSearchTerm, term)
  } else {
    params.delete(urlSearchTerm)
  }

  return params.toString()
}
